export const RECEIVE_PICKER_CONTENT = 'RECEIVE_PICKER_CONTENT'
export const CLEAR_PICKER_CONTENT = 'CLEAR_PICKER_CONTENT'
